import { useLingui } from '@lingui/react';
import styled from 'styled-components';

//import { formatDate, renderFullPath } from '~/utils/common/utils';
import iconStar from '@assets/images/icon/icon-star-gold.png';
//import iconStarDisabled from '@assets/images/icon/icon-friend-add.png';
import iconFriendHover from '@assets/images/icon/icon-friend-add-hover.png';
// import { WonBattleItem } from '~/components/ui/won-battle-item';
// import { SSpanTableAdvice, SSpanTableName } from '~/components/styles/styles';
import ModalListAuto from '~/components/ui/modal-list-auto';
import { WrapperListAuto } from '~/components/ui/wrapper-list-auto';
import { StoredFinishedBattle } from '~/gql/battles/battles';
import { formatDate, renderFullPath } from '~/utils/common/utils';
import { SSpanTableAdvice, SSpanTableName } from '~/components/styles/styles';
import { classic } from '~/themes';
import { Loading } from '~/components/ui/loading';

interface IProps {
  open: boolean;
  onClose: () => void;
  finishedBattles?: StoredFinishedBattle[];
  loading: boolean;
}
type TProps = IProps;

export default function FriendsdDialog({
  open,
  onClose,
  finishedBattles,
  loading,
}: TProps) {
  const { i18n } = useLingui();

  return (
    <ModalListAuto onClose={onClose} open={open}>
      <WrapperListAuto onClose={onClose} title={`${i18n._('common.history')}`}>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <STableWrapper>
              <STable>
                <tbody>
                  {finishedBattles &&
                    finishedBattles.map((battle, index) => (
                      <STr key={index}>
                        <td>
                          <SDivNameWrapper>
                            {battle.opponent.avatar?.fileName && (
                              <SDivAvatar>
                                <img
                                  src={renderFullPath(
                                    battle.opponent.avatar?.fileName
                                  )}
                                  alt=""
                                />
                              </SDivAvatar>
                            )}
                            <SDivName>
                              <SSpanTableName>
                                {battle.opponent.username}
                              </SSpanTableName>
                              <SSpanTableAdvice>
                                {`réalisé le ${formatDate(battle.date as Date)}`}{' '}
                                | {battle.isChallenger ? 'Défieur' : 'Défié'}
                              </SSpanTableAdvice>
                            </SDivName>
                          </SDivNameWrapper>
                        </td>
                        <td>
                          <SDivStatus $isWinner={battle.isWinner}>
                            <SSpan>{battle.isWinner ? 'Gagné' : 'Perdu'}</SSpan>
                          </SDivStatus>
                        </td>
                      </STr>
                    ))}
                </tbody>
              </STable>
            </STableWrapper>
          </Container>
        )}
      </WrapperListAuto>
    </ModalListAuto>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const SDivName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
`;

const SDivNameWrapper = styled.div`
  background-color: transparent;
  height: 46px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const SDivStatus = styled.div<{ $isWinner?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 12.8px;
  background: ${({ $isWinner }) =>
    $isWinner
      ? 'linear-gradient(180deg, #30D75F 0%, #1DA543 100%)'
      : 'linear-gradient(180deg, rgba(248, 103, 103, 0.8) 0%, #f86767 100%)'};
  box-shadow: 0px -3.2px 2.4px 0px rgba(0, 0, 0, 0.25) inset;
  padding: 2px 8px;
  min-width: 100px;
  height: auto;
`;

export const SSpan = styled.span<{ $color?: string; $align?: string }>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorWhite}`)};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.1rem;
  text-transform: uppercase;

  text-align: ${({ $align }) => ($align ? $align : 'left')};
  user-select: none;
  @media screen and (max-height: 600px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 450px) {
    margin-bottom: 10px;
    font-size: 0.9rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 0.9rem;
  }
`;

const SDivAvatar = styled.div`
  border-radius: 50%;
  background-color: #fff;
  height: 40px;
  width: 44px;
  position: relative;
  border: 3px solid #fff;
  margin-right: 20px;

  img {
    position: absolute;
    object-fit: contain;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
`;

const STableWrapper = styled.div`
  /* height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 20px;

  @media screen and (max-height: 800px) {
    padding: 10px;
  }

  @media screen and (max-height: 450px) {
    padding: 10px;
  }

  @media screen and (max-width: 450px) {
    padding: 10px;
  } */

  flex-grow: 1;
  width: 100%;
  overflow-y: auto;
  padding: 20px 20px 130px 20px;

  @media screen and (max-height: 800px) {
    padding: 10px 10px 130px 40px;
  }

  @media screen and (max-height: 450px) {
    padding: 10px 10px 100px 40px;
  }

  @media screen and (max-width: 450px) {
    padding: 10px 10px 100px 10px;
  }
`;

const STr = styled.tr<{ $isFriend?: boolean }>`
  &:nth-of-type(even) {
    /* background-color: #ffffff80; */
    user-select: none;
  }
  &:nth-of-type(odd) {
    background-color: transparent;
    user-select: none;
  }
  td {
    color: #113969;
    font-family: 'Riffic Free', sans-serif;
    background-color: transparent;
    font-weight: bold;
    font-size: 1.1rem;
    padding: 8px 12px;
    user-select: none;

    @media screen and (max-width: 450px) {
      font-size: 0.9rem;
      padding: 5px 8px;
    }
    @media screen and (max-width: 290px) {
      font-size: 0.8rem;
      padding: 5px 8px;
    }
    @media screen and (max-height: 600px) {
      font-size: 0.9rem;
      padding: 5px 8px;
    }
    @media screen and (max-height: 450px) {
      font-size: 0.8rem;
      padding: 5px 8px;
    }
    @media screen and (max-height: 290px) {
      font-size: 0.7rem;
      padding: 5px 8px;
    }

    &:first-of-type {
      text-align: center;
      width: 70%;
      user-select: none;
    }

    &:last-of-type {
      padding-right: 10px;
      text-align: right;
      width: 30%;
      user-select: none;
    }
  }

  &:hover {
    background-color: rgba(83, 210, 215, 0.2);
    & > td > div > div > span {
      &.hidden {
        visibility: visible;
        height: auto;
        opacity: 1;
      }
    }
    & > td > button {
      background: ${({ $isFriend }) => {
        if ($isFriend) return `url(${iconStar}) center/contain no-repeat`;
        return `url(${iconFriendHover}) center/contain no-repeat`;
      }};
    }
  }
`;

const STable = styled.table`
  text-align: left;
  position: relative;
  border-collapse: collapse;
  width: 100%;
`;
